import { Link } from '@remix-run/react'
import { siteConfig } from '#app/utils/constants/brand'
import { routesInSection } from '#app/config/marketing-routes'
import { Logo } from '#app/components/logo'
import { ThemeSwitcherHome } from '#app/components/misc/theme-switcher'

type FooterLink = { label: string; href: string; external?: boolean }
type FooterSection = { title: string; links: FooterLink[] }

const SECTIONS: FooterSection[] = [
  {
    title: 'Product',
    links: [
      ...routesInSection('Product').map((r) => ({ label: r.label, href: r.path })),
      { label: 'Pricing', href: '/#pricing' },
    ],
  },
  {
    title: 'Resources',
    links: routesInSection('Resources').map((r) => ({ label: r.label, href: r.path })),
  },
  {
    title: 'Company',
    links: [],
  },
]

export function MarketingFooter() {
  const contactHref = `mailto:${siteConfig.email}`

  return (
    <footer className="z-10 border-t border-border/40">
      <div className="mx-auto flex w-full max-w-screen-lg flex-col gap-10 px-6 py-12">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          <div className="col-span-2 flex flex-col gap-3 md:col-span-1">
            <Link to="/" prefetch="intent" className="flex items-center gap-2">
              <Logo width={24} height={24} />
              <span className="text-sm font-semibold text-primary">Inbox Bridge</span>
            </Link>
            <p className="max-w-xs text-xs leading-relaxed text-muted-foreground">
              Turn any email into a webhook. Parsed JSON, automatic retries, one-click replay.
            </p>
          </div>
          {SECTIONS.map((section) => (
            <div key={section.title} className="flex flex-col gap-3">
              <h3 className="text-xs font-semibold uppercase tracking-wide text-primary">
                {section.title}
              </h3>
              <ul className="flex flex-col gap-2">
                {section.title === 'Company' && (
                  <li>
                    <a
                      href={contactHref}
                      className="text-sm text-muted-foreground hover:text-primary">
                      Contact
                    </a>
                  </li>
                )}
                {section.links.map((link) =>
                  link.external ? (
                    <li key={link.href}>
                      <a
                        href={link.href}
                        className="text-sm text-muted-foreground hover:text-primary">
                        {link.label}
                      </a>
                    </li>
                  ) : (
                    <li key={link.href}>
                      <Link
                        to={link.href}
                        prefetch="intent"
                        className="text-sm text-muted-foreground hover:text-primary">
                        {link.label}
                      </Link>
                    </li>
                  ),
                )}
              </ul>
            </div>
          ))}
        </div>
        <div className="flex flex-col items-start justify-between gap-4 border-t border-border/40 pt-6 md:flex-row md:items-center">
          <p className="text-xs text-muted-foreground">
            &copy; {new Date().getFullYear()} Inbox Bridge. All rights reserved.
          </p>
          <ThemeSwitcherHome />
        </div>
      </div>
    </footer>
  )
}
